const objectSubsetSelector = (input, count, shuffler) => {
  const result = {};

  shuffler(Object.keys(input))
    .filter((_, index) => index < count)
    .forEach(key => {
      result[key] = input[key];
    });

  return result;
};

export default objectSubsetSelector;
